var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStandardDeviation = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M11.712 15.375q-.922 0-1.627-.37A2.65 2.65 0 0 1 9.01 13.89q-.384-.741-.384-1.805 0-1.248.448-2.002a2.6 2.6 0 0 1 1.268-1.113q.82-.346 1.934-.346h3.1v.84h-1.563q.333.297.551.68.231.384.346.866.128.482.128 1.075 0 .668-.205 1.274a3 3 0 0 1-.59 1.05q-.383.445-.973.705-.588.26-1.357.26Zm.025-.902q.691 0 1.128-.322a1.87 1.87 0 0 0 .64-.853q.205-.544.205-1.187 0-.531-.115-1.001a3.4 3.4 0 0 0-.32-.878 3.7 3.7 0 0 0-.551-.766h-.449q-.832 0-1.396.272a1.72 1.72 0 0 0-.845.84q-.27.57-.27 1.508.001.693.206 1.237.204.544.64.853.435.297 1.127.296Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStandardDeviation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/standard-deviation.9ce22750.svg";